import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    cardImage: {
      width: '100%',
      height: '100%',
    },
    cardIcon: {
      zIndex: 1,
      width: 40,
      height: 40,
      margin: '16px 0 82px 16px',
      [theme.breakpoints.up('md')]: {
        width: 64,
        height: 64,
        margin: 24,
      },
    },
  }),
);
